export default __webpack_public_path__ + "static/media/panque-limon.34ddef48.jpg";